// Auto-extracted from app.jsx

export const BLOCKER_TYPES = {
  INCOMPLETE_EQ: { id: "incomplete_eq", label: "Missing Questions", severity: "high", color: "red" },
  PLACEHOLDER: { id: "placeholder", label: "Placeholder Rationale", severity: "high", color: "red" },
  OVERDUE_REVIEW: { id: "overdue_review", label: "Overdue Review", severity: "high", color: "red" },
  MISSING_EVIDENCE: { id: "missing_evidence", label: "Missing Evidence", severity: "medium", color: "amber" },
  LOW_QUALITY_SCORE: { id: "low_quality", label: "Quality Score Below 70%", severity: "high", color: "red" },
};

// Quality score threshold for attestation (70/100)